export const ACCOUNT_SUBSCRIPTIONS_ALL = 'ACCOUNT_SUBSCRIPTIONS_ALL';
export const ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_GET = 'ACCOUNT_SUBSCRIPTIONS_GET';
export const ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_CREATE = 'ACCOUNT_SUBSCRIPTIONS_CREATE';
export const ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_UPDATE = 'ACCOUNT_SUBSCRIPTIONS_UPDATE';
export const ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_DELETE = 'ACCOUNT_SUBSCRIPTIONS_DELETE';
export const ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_CANCEL = 'ACCOUNT_SUBSCRIPTIONS_CANCEL';
export const ACCOUNT_SUBSCRIPTIONS_CANCEL_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_CANCEL_SUCCESS';
export const ACCOUNT_SUBSCRIPTIONS_REACTIVATE = 'ACCOUNT_SUBSCRIPTIONS_REACTIVATE';
export const ACCOUNT_SUBSCRIPTIONS_REACTIVATE_SUCCESS = 'ACCOUNT_SUBSCRIPTIONS_REACTIVATE_SUCCESS';